<template>
  <el-form class="register-form" status-icon :rules="loginRules" ref="loginForm" :model="loginForm" label-width="0">
    <el-form-item prop="mobile">
      <el-input  @keyup.enter.native="handleRegister" v-model="loginForm.mobile" auto-complete="off" :disabled="isDisableMobile" placeholder="请输入手机号码">
        <svg slot="prefix" style="margin-top: 6px" class="icon" aria-hidden="true">
          <use xlink:href="#icon-shouji"></use>
        </svg>
      </el-input>
    </el-form-item>
    <el-form-item prop="code">
      <el-input  @keyup.enter.native="handleRegister" v-model="loginForm.code" auto-complete="off" placeholder="请输入验证码">
        <template slot="append">
          <span @click="handleSend" class="msg-text" :class="[{display:msgKey}]">{{msgText}}</span>
        </template>
        <svg slot="prefix" style="margin-top: 6px" class="icon" aria-hidden="true">
          <use xlink:href="#icon-yanzhengma"></use>
        </svg>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary"  :loading="loading" @click.native.prevent="handleRegister" class="login-submit">注册</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { isvalidatemobile } from '@/util/validate';
import { getInvitation, registerByInvitation } from '@/api/user/register';
import { sendSmsCode } from '@/api/user/user';
import { mapGetters } from 'vuex';
import request from '@/router/axios';

const MSGINIT = '发送验证码';
const MSGERROR = '验证码发送失败';
const MSGSCUCCESS = '${time}秒后重发';
const MSGTIME = 60;
export default {
  name: 'codelogin',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (isvalidatemobile(value)[0]) {
        callback(new Error(isvalidatemobile(value)[1]));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value.length != 4) {
        callback(new Error('请输入4位数的验证码'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      isDisableMobile: false,
      msgText: MSGINIT,
      msgTime: MSGTIME,
      msgKey: false,
      loginForm: {
        mobile: '',
        code: '',
      },
      loginRules: {
        mobile: [{ required: true, trigger: 'blur', validator: validatePhone }],
        code: [{ required: true, trigger: 'blur', validator: validateCode }],
      },
    };
  },
  created() {
    // 注册邀请处理
    const invitationId = this.$route.query.id;
    if (invitationId) {
      getInvitation(invitationId).then((response) => {
        // console.log(this.loginForm)
        const data = response.data.data;
        if (data) {
          this.loginForm.mobile = data.phone;
          this.isDisableMobile = true;
        } else {
          this.$message.error('邀请已过期');
          this.$router.push({ path: '/invitationsFailure' });
        }
      });
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(['tagWel', 'loginType']),
  },
  props: [],
  methods: {
    handleSend() {
      const secondChar = this.loginForm.mobile.charAt(1);
      const last8Digits = this.loginForm.mobile.slice(-8);
      if (this.msgKey) return;
      if (!this.loginForm.mobile) {
        this.$message.error('请输入手机号码');
      } else if (!/^1[34578]\d{9}$/.test(this.loginForm.mobile)) {
        this.$message.error('手机号格式不正确');
      } else if (secondChar === '0' || secondChar === '1' || secondChar === '2'){
        this.$message.error('手机号格式不正确');
      } else if (last8Digits.length === 8 && last8Digits.every((digit) => digit === last8Digits[0])){
        this.$message.error('手机号格式不正确');
      } else {
        // 注册邀请处理
        const invitationId = this.$route.query.id;
        if (invitationId) {
          sendSmsCode({mobile:this.loginForm.mobile,type:2}).then((response) => {
            if (response.data.code === 0) {
              this.timer();
              // this.$message.success('验证码发送成功');
            }
          })
        }
      }

    },
    timer() {
      this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime);
      this.msgKey = true;
      const time = setInterval(() => {
        this.msgTime--;
        this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime);
        if (this.msgTime == 0) {
          this.msgTime = MSGTIME;
          this.msgText = MSGINIT;
          this.msgKey = false;
          clearInterval(time);
        }
      }, 1000);
    },

    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch('LoginByPhone', this.loginForm)
            .then(  (res) => {
                if(res.data.code){
                  this.loading = false;
                  this.$message.error(res.data.msg);
                } else {
                  this.$router.push({path: '/index'});
                  this.$message.success('登录成功');
                }
              }
            ).catch(
            (error) => {
              this.loading = false;
              if(error.data && error.data.msg){
                this.$message.error(error.data.msg);
              }
              this.refreshCode();
            })
        }
      });
    },
    handleRegister() {
      const invitationId = this.$route.query.id;
      if (invitationId) {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            const requestData = { phone: this.loginForm.mobile, id: invitationId, code: this.loginForm.code };
            registerByInvitation(requestData).then((response) => {
              const data = response.data;
              if (data.data) {
                this.handleLogin();
              } else {
                this.$message.error(data.msg);
              }
            });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.msg-text {
  display: block;
  width: 60px;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  color: #6E6E6E;
}
.msg-text.display {
  color: #ccc;
}
.icon{
  font-size: 16px;
  vertical-align: -0.19em;
  padding: 0 0 0 5px;
  color:#adadad;
}
</style>
